const locale = {
  id: 'TeacherConstant',
  code: 'CN',
  text: {
    "./images/teacher_en@2x.png": "./images/teacher@2x.png",
    'Administration Management': '多角色教务管理',
    'Administration Management allows you to create teachers, which you can appoint them in different classes. You could also send an invitation via text to teachers, which allows them to join this platform and help you management your school. Teachers could also download ClassTopBase for School Staff app on both Apple Store and Google Play to help them better manage their classes': '学校可直接创建并保存一个教务角色，也可以邀请一名老师加入学校的教学管理，配合着专为老师定制的APP一起用，可提高数倍教学效率。',
  }
}

export const onBoardingContents = {
  // we show this when student state is 'current'
  current: {
    title: __('Administration Management', locale),
    text: __('Administration Management allows you to create teachers, which you can appoint them in different classes. You could also send an invitation via text to teachers, which allows them to join this platform and help you management your school. Teachers could also download ClassTopBase for School Staff app on both Apple Store and Google Play to help them better manage their classes', locale),
    image: require(__('./images/teacher_en@2x.png', locale)),
    showArrow: true,
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/Teacher/constant.js